import * as React from 'react';
import ReactTable from 'react-table';
import { DataRequest } from './request';
import CustomPagination from '../sys/pagination';

class State {
    data?: Array<any>;
}

interface ColumnSet {
  _?: Array<{}>;
}

interface Props {
    className ?: string;
    columnSets: ColumnSet;       // on object where each member is an array of columns
    groups: Array<string>;
    groupby?: Array<string>;
    filter: string | null;
    filters: {};
    timerange?: string | number;
    namespace?: string;
    metrics?: Array<string>;
    refreshRate?: number;
    streamName ?: string;
    setFilter ?: string;
    statusFilter ?: string;
    formatFilter ?: string;
    initiatorFilter ?: string;
    showTopLevel ?: boolean;
    onDataUpdated ?: (data: {}) => void;
    treeOrder ?: boolean;
}

export default class DataExportReactView extends React.Component<Props, State> {

    public static defaultProps: Partial<Props> = {
        timerange: 'current',
        namespace:  'api.surveyor.abr',
        metrics: [
            'session.status',
            'session.statistics.cycle',
            'session.statistics.fifteen'
        ],
        treeOrder: false
    };

    public static transformData(data: any) {
        // expect array of sessions (status + statistics)
        if (data.results.session)
            data = data.results.session;
        else
            data = [];

        if (Array.isArray(data)) {
            data.forEach( (session: any) => {
                if ( session.statistics ) {
                    const {cycle, fifteen} = session.statistics;
                    if (cycle && Array.isArray(cycle) && cycle.length > 0) {
                        session.statistics = {
                            ...cycle[0],
                            fifteen: (Array.isArray(fifteen) && fifteen.length > 0 && fifteen[0]) || undefined
                        };
                    // SAN-2885 there is a small race condition immediately after starting a session where cycle is empty,
                    // but fifteen is valid. This causes a runtime-error in the react view so lets copy fifteen or minute
                    // stats to compensate (cycle, minute and fifteen would be equal at this point in the race).
                    } else if (fifteen && Array.isArray(fifteen) && fifteen.length > 0) {
                        console.warn('SAN-2885 cycle binstats empty while fifteen is valid (' + session.status.name + ')');
                        session.statistics = {
                            ...fifteen[0],
                            fifteen: fifteen[0]
                        };
                    }
                }
            });
        }
        return data;
    }

    buildColumns(groupColumns: boolean, columnSetSelection: string | Array<string>) {
        /* Use the collection of column sets to build the set of columns to be shown.
         * Each string in the parameter columnSetSelection array will pick a set from the columnSets collection.
         */
        let columns: Array<object> = [];    // our output set

        if (typeof columnSetSelection === 'string') {
            // expect comma-delimited string, convert string to array of values
            columnSetSelection = columnSetSelection.split(',');
        }

        // push the main columns that are always on
        if (this.props.columnSets._ !== undefined)
            columns.push.apply(columns, this.props.columnSets._);

        // build set of columns based on selected groups
        for (let i = 0; i < columnSetSelection.length; i++) {
            // little hack to always include general columns is to start this loop at -1
            let columnLabel = columnSetSelection[i];

            if (this.props.columnSets[columnLabel] !== undefined) {
                /* figure out how we are going to add the columns to the view,
                 * we can add as flat collection of columns, grouped columns, or by an alternate view
                 */

                if (groupColumns) {
                    // add as grouped columns as per our original column sets
                    columns.push({
                        Header: columnLabel,
                        columns: this.props.columnSets[columnLabel]
                    });
                } else
                // a little hack to not require a loop; we call the .apply() to specify the arguments to
                // push as an array which we already conveniently have.
                    columns.push.apply(columns, this.props.columnSets[columnLabel]);
            }
        }
        return columns;
    }

    render () {
        const {
            timerange, namespace, metrics, filters, groups, groupby,
            refreshRate, onDataUpdated, treeOrder
        } = this.props;
        let columns = this.buildColumns(true, groups);

        // build params to our Data Request
        const params = {
            timerange,
            namespace,
            metrics,
            ...filters
        };

        return (
            <DataRequest
                auto                // automatically request on data change (filter change)
                spinner             // show spinner when foreground loading (ex. on first load)
                debounce={1500}     // debounce multiple requests (i.e. as user types in filter box)
                interval={refreshRate}
                method="post"
                endpoint="api/analytics"
                transform={DataExportReactView.transformData}
                response={onDataUpdated}
                treeOrder={treeOrder}
                data={params}
            >{ (request: any) => {
                // save the refresh function for later use
                // this.dataRefresh = request.refresh;

                // render a react table using the request data
                return (
                    <ReactTable
                        className="content-bg transaction-log -striped -highlight outside-scroll"
                        pivotBy={groupby}
                        NoDataComponent={request.spinner ? () => null : undefined}
                        onFetchData={request.refresh}
                        data={request.data || []}
                        columns={columns}
                        defaultPageSize={15} // CensusView default
                        PaginationComponent={CustomPagination}
                    />);
            }}
            </DataRequest>
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/api/react-view.tsx